import React from "react";
import Page2 from "../components/Page2";
import Page3 from "../components/Page3";
import Page4 from "../components/Page4";
import Header from "../components/Header";
import Page2_1 from "../components/Page2_1";
import { Helmet } from "react-helmet";

export default function WhoisAndromeda() {
  return (
    <div>
      <Helmet>
        <title>Features | Andromeda</title>
        <meta
          name="description"
          content="Andromeda-Sim is a leading software provider for flight simulators, specializing in quality monitoring, performance control, and simulator maintenance. Discover how we help aviation training centers, flight schools, and academies optimize their training and simulator operations."
        />
        <meta
          name="keywords"
          content="Andromeda-Sim, flight simulator software, simulator maintenance, aviation training, flight training centers, aviation academies, flight schools, pilot training, flight simulation engineer, simulator performance, simulator repair, simulator configuration"
        />
      </Helmet>
      <div className="">
        <Header />
      </div>
      <Page2 />
      <Page2_1 />
     
    </div>
  );
}
